import ABCyaLib from "@abcya/abcya_lib";
import Bitmap from "@abcya/abcya_lib/src/Bitmap";
import ABCyaPhaser from "@abcya/abcya_phaser";

export function SavePrint(SaveOrPrint,Scene,Skip = false)
{

    if (SaveOrPrint === "Save")
    {
        //console.log("Called save");
        return doSave(Scene.game,Skip);
    }
    else if(SaveOrPrint === "Print")
    {
        return doPrint(Scene.game,Skip);
    }
}

function doPrint(game, Trim = false) {

    const { canPrintImages } = ABCyaLib.Environment.instance.capabilities;

    if(canPrintImages)
    {

        if(Trim)
        {
            game.renderer.snapshotArea(0,0,1024,768,async (image)=>{
                let rotatedImage = await Bitmap.rotateHTMLImage(image)
                let printStatus = await ABCyaLib.PrintSave.instance.printImage(rotatedImage)
                return (printStatus)
            })
        }
        else
        {
            game.renderer.snapshot(async (image)=>{
                let rotatedImage = await Bitmap.rotateHTMLImage(image)
                let printStatus = await ABCyaLib.PrintSave.instance.printImage(rotatedImage)
                return (printStatus)
            })
        }
    }
}

function doSave(game, Trim = false) {

    const { canSaveImages } = ABCyaLib.Environment.instance.capabilities;

    if(canSaveImages)
    {
        if(Trim)
        {
            game.renderer.snapshotArea(96,0,831,768,async (image)=>{
                let saveStatus = await ABCyaLib.PrintSave.instance.saveImage(image, {fileName: ABCyaPhaser.Localization.instance.getLocalizedString("save_print_output.filename")})
                return (saveStatus)
            })
        }
        else
        {
            game.renderer.snapshot(async (image)=>{
                let saveStatus = await ABCyaLib.PrintSave.instance.saveImage(image, {fileName: ABCyaPhaser.Localization.instance.getLocalizedString("save_print_output.filename")})
                return (saveStatus)
            })
        }
    }
}
